/** Shown on a control that is disabled because the month-end job is running. */
export const MAINTENANCE_TOOLTIP = "Unavailable during scheduled maintenance";

export const MAINTENANCE_ALERT_TITLE = "Temporarily unavailable";

export const MAINTENANCE_ALERT_MESSAGE =
    "We are performing scheduled maintenance. Updates on this page are unavailable right now, please try again later.";

/** Shown when a save was attempted after the job started, so the member knows nothing was saved. */
export const MAINTENANCE_SAVE_BLOCKED_MESSAGE =
    "We are performing scheduled maintenance, so your changes haven't been saved. Please try again in a few minutes.";
